// extracted by mini-css-extract-plugin
module.exports = {"Button":"LanguageSwitcher_Button_Lvmu0","Item_label":"LanguageSwitcher_Item_label_31mLR"};